<template>
  <Teleport to="body">
    <Transition name="alw-fade">
      <div v-if="showWarning" class="alw-overlay">
        <div class="alw-box" role="alertdialog" aria-live="assertive" aria-label="Aviso de inatividade">
          <div class="alw-countdown">{{ secondsLeft }}</div>
          <div class="alw-title">Você ainda está aí?</div>
          <div class="alw-desc">
            Por inatividade, você será desconectado automaticamente em
            <strong>{{ secondsLeft }}s</strong>.
          </div>
          <div class="alw-actions">
            <button type="button" class="alw-btn alw-btn--primary" @click="handleContinueSession">
              Continuar logado
            </button>
            <button type="button" class="alw-btn alw-btn--muted" @click="handleLogoutNow">
              Deslogar agora
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { showWarning, secondsLeft, continueSession, performLogout } from '@/composables/useAutoLogout'

const store  = useStore()
const router = useRouter()

function handleContinueSession() {
  continueSession(store)
}

function handleLogoutNow() {
  performLogout(store, router)
}
</script>

<style scoped>
.alw-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, .55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.alw-box {
  background: var(--white);
  border-radius: var(--r);
  padding: 32px;
  width: 340px;
  max-width: calc(100vw - 32px);
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, .3);
}

.alw-countdown {
  font-size: 40px;
  font-weight: 800;
  color: var(--red);
  margin-bottom: 8px;
  font-variant-numeric: tabular-nums;
}

.alw-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ink-80);
  margin-bottom: 6px;
}

.alw-desc {
  font-size: 13px;
  color: var(--ink-40);
  line-height: 1.5;
  margin-bottom: 20px;
}

.alw-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.alw-btn {
  padding: 10px 16px;
  border-radius: var(--r-sm);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  border: none;
  font-family: inherit;
}

.alw-btn--primary {
  background: var(--red);
  color: #fff;
}

.alw-btn--muted {
  background: transparent;
  color: var(--ink-40);
  border: 1px solid var(--ink-10);
}

.alw-fade-enter-active,
.alw-fade-leave-active {
  transition: opacity .15s ease;
}

.alw-fade-enter-from,
.alw-fade-leave-to {
  opacity: 0;
}
</style>
